import type { RefObject } from 'react';
import { useEffect, useEffectEvent, useRef } from 'react';

const useOnBlurComponent = <T extends HTMLElement>(
  onBlur: () => void,
  overrideRef?: RefObject<T | null>,
) => {
  const initialRef = useRef<T>(null);
  const ref = overrideRef || initialRef;

  const onBlurEvent = useEffectEvent(onBlur);

  useEffect(
    () => () => {
      onBlurEvent();
    },
    [],
  );

  const handleBlur = () => {
    // Check the newly focused element in the next tick of the event loop
    setTimeout(() => {
      // Check if the new activeElement is not topic input
      if (
        !ref.current?.contains(document.activeElement) &&
        !document.getElementById('popup-root')?.contains(document.activeElement)
      ) {
        onBlurEvent();
      }
    }, 0);
  };

  return {
    ref,
    handleBlur,
  };
};

export default useOnBlurComponent;
